import axios from './axiosInstance';

export const getVesselEmissionSummary = async (
  vesselId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/emissions/summary`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

export const getVesselEmissionOverview = async (vesselId, startDate, endDate, voyageId = null) => {
  const url = `/vessels/${vesselId}/emissions/overview`;
  const params = {};

  if (voyageId) {
    params.voyageId = voyageId;
  } else if (startDate && endDate) {
    params.start = startDate;
    params.end = endDate;
  }

  try {
    const res = await axios.get(url, { params });
    return res.data.data;
  } catch (error) {
    console.error("API Error in getVesselEmissionOverview:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
      throw new Error(error.response.data.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");
    } else {
      console.error("Request setup error:", error.message);
      throw new Error(`Request error: ${error.message}`);
    }
  }
};

const fetchVesselEmissionData = async (endpoint, vesselId, startDate, endDate, voyageId = null) => {
  try {
    const url = `/vessels/${vesselId}/emissions/${endpoint}`;

    // Build query params
    const params = new URLSearchParams();
    if (voyageId) {
      params.append("voyageId", voyageId);
    } else {
      params.append("start", startDate);
      params.append("end", endDate);
    }

    const res = await axios.get(`${url}?${params.toString()}`);

    return res.data?.data || null;
  } catch (error) {
    console.error(`[API ERROR] Failed to fetch ${endpoint} for Vessel ID: ${vesselId}`, error);
    throw error;
  }
};

export const getVesselEmissionFuelEfficiency = async (vesselId, startDate, endDate, voyageId = null) => {
  return fetchVesselEmissionData("fuelefficiency", vesselId, startDate, endDate, voyageId);
};

export const getVesselEmissionLoadingStatus = async (vesselId, startDate, endDate, voyageId = null) => {
  return fetchVesselEmissionData("loadingstatus", vesselId, startDate, endDate, voyageId);
};

export const getVesselEmissionFuelConsumption = async (vesselId, startDate, endDate, voyageId = null) => {
  return fetchVesselEmissionData("fuelconsumption", vesselId, startDate, endDate, voyageId);
};

export const getVesselEmissionState = async (vesselId, startDate, endDate, voyageId = null) => {
  return fetchVesselEmissionData("stateofcharge", vesselId, startDate, endDate, voyageId);
};
